import filterOptions from '../actions/filterOptions'

export default [filterOptions]



// WEBPACK FOOTER //
// ./src/modules/client/chains/filterOptions.js